var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocksTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "20 0 1100 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "blocks-top-a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1126,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h1126v44H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    mask: "url(#blocks-top-a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "blocks-top-b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: -17,
    width: 1180,
    height: 71
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M-12-17h1180v71H-12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#blocks-top-b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M1141.74 16.272H970.63v30.544h171.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E26FAB",
    d: "M1126.01 26.805h-285.8v40.024h285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#254A5D",
    d: "M759.746 1H506.318v40.024h253.428z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#AAD037",
    d: "M622.858 31.544H368.506v40.024h254.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M531.291 14.166H296.362V51.03h234.929z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#715477",
    d: "M368.506 6.266H167.799v31.598h200.707z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#647559",
    d: "M455.448 32.598H156.699v46.87h298.749z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FED000",
    d: "M212.194 23.118H14.262V54.19h197.932z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAD037",
    d: "M983.577 8.9h-171.11v30.543h171.11z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#DA3336",
    d: "M972.478 21H652.456v57.402h320.022z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksTop);
export default __webpack_public_path__ + "static/media/blocks-top.7bdc78b0.svg";
export { ForwardRef as ReactComponent };